// Track the mutation ids this tab issued, so the WS echo of our own change can be
// suppressed — we already applied it optimistically. Bounded FIFO; old ids age out.
const MAX_TRACKED = 100;
const mine = new Set<string>();

/** A fresh id to tag an outgoing mutation with (also remembered for echo-suppression). */
export function newMutationId(): string {
	const id = crypto.randomUUID();
	mine.add(id);
	if (mine.size > MAX_TRACKED) {
		const oldest = mine.values().next().value;
		/* v8 ignore next -- oldest is always defined here (set is over capacity) */
		if (oldest !== undefined) mine.delete(oldest);
	}
	return id;
}

/** True when an event echoes a mutation this tab made (suppress it — already applied). */
export function isOwnMutation(mutationId: string | null): boolean {
	return mutationId !== null && mine.has(mutationId);
}
